import React from 'react';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
}
export function PageHeader({
  title,
  subtitle
}: PageHeaderProps) {
  return <div className="shrink-0 border-b border-slate-100 bg-white/80 px-5 pb-4 pt-6 backdrop-blur-sm" data-id="element-100" data-mp="1idu0iae4q1jr">
      <h1 className="text-xl font-semibold text-slate-900" data-id="element-101" data-mp="1md2p70ubb98g">{title}</h1>
      {subtitle && <p className="mt-0.5 text-sm text-slate-400" data-id="element-102" data-mp="1r7gohec3i0ie">{subtitle}</p>}
    </div>;
}